module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_5-332cad9be0aa9e49b7da039bb09f2019.jpg";